/**
 * プライベートマッチの定数（#153、[ADR-024](../../../../docs/adr/024-private-match-rooms.md)）。
 *
 * **値の正はここだけ。** マイグレーションにも API にも数字を書かない。
 */
/**
 * ルームの状態。
 *
 * | 状態 | 意味 |
 * | --- | --- |
 * | `OPEN` | ゲストを待っている |
 * | `FULL` | 2 人そろった。準備完了を待っている |
 * | `MATCHED` | 対戦が成立した。`battleId` がある |
 * | `CANCELLED` | ホストが取りやめた |
 * | `EXPIRED` | 成立しないまま期限が来た |
 *
 * **`EXPIRED` は時刻から導く。** D1 の行は期限が来ても `OPEN` / `FULL` のまま残ることがある
 * （見に来た人がいないと書き換える契機が無い）。API は `expiresAt` と今の時刻から判断して返す。
 */
export const PRIVATE_MATCH_STATUSES = ['OPEN', 'FULL', 'MATCHED', 'CANCELLED', 'EXPIRED'];
/** リクエストした人がそのルームのホストかゲストか。 */
export const PRIVATE_MATCH_ROLES = ['HOST', 'GUEST'];
/**
 * ルームの有効期限（秒）。作った時刻から数える。
 *
 * 対面なら数分で揃う。リモートでも、LINE などでリンクを送って相手がアプリを開くまでに足りる長さ。
 * 長くすると、使われないルームがコードを押さえ続ける。
 */
export const PRIVATE_MATCH_TTL_SECONDS = 15 * 60;
/** ルームコードの長さ。 */
export const ROOM_CODE_LENGTH = 6;
/**
 * ルームコードに使う文字（31 文字）。
 *
 * **読み違えやすい文字を入れない**（`0` と `O`、`1` と `I` と `L`）。コードは声に出して伝えたり、
 * 画面を見ながら打ったりする。6 文字で 31^6 ≒ 8.9 億通り。
 */
export const ROOM_CODE_ALPHABET = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
/**
 * ロビーの WebSocket の生存確認（#153）。**この文字列と一字一句同じ**ときだけ、Durable Object を起こさずに
 * `LOBBY_PONG` を返す（`setWebSocketAutoResponse`。空白の入れ方が違うと DO が起きて処理する）。
 *
 * アプリは待っている間、これを数十秒おきに送る。モバイルの回線は、何も流れない接続を途中の機器が切ることがある。
 */
export const LOBBY_PING = '{"type":"ping"}';
export const LOBBY_PONG = '{"type":"pong"}';
